<section class="login">
  <div class="side-adv">
    <div class="panel panel-adv adv-01">
      <figure class="adv adv-01"></figure>
      <div class="panel-adv__footer">
        <p class="typo note uppercase semi-condensed fw300 enterprise-panel__footer__lead">Trusted by the world's smartest companies</p>
        <img class="panel-adv__logos" src="assets/images/iso-GilletteOnDemand@2x.png">
      </div>
    </div>
  </div>
  <div class="side-main">
    <router-outlet></router-outlet>
  </div>
</section>
